import { useQuery } from '@tanstack/react-query';

import { getDocumentPreviewUrl } from '@/features/documents/api/get-document-preview-url';

export const useDocumentPreviewUrl = (filePath: string | null) => {
  return useQuery({
    queryKey: ['document-preview-url', filePath],
    queryFn: () => {
      if (!filePath) {
        throw new Error('File path is required');
      }
      return getDocumentPreviewUrl(filePath);
    },
    enabled: !!filePath,
    staleTime: 3600000,
    gcTime: 3600000,
  });
};
